import React from "react";
import { useState } from 'react';
import './Redes.css';
import imgSwitch from '../../assets/images/switches.png';
import imgRouter from '../../assets/images/routes22.png';
import imgFirewall from '../../assets/images/Firewall.png';
import imgAccessPoint from '../../assets/images/Accespoint.png';
import imgWifi from '../../assets/images/Mesh.png';
import imgMemoriaSer from '../../assets/images/memoriaserv.png';
import imgTarjetasred from '../../assets/images/tarjetas.png';
import imgCableRed from '../../assets/images/cablesred.png';
import imgRacks from '../../assets/images/gabinete2.avif';
import imgConectores from '../../assets/images/panel.webp';
import imgFuente from '../../assets/images/fuente.png';
import imgAdaptadorRed from '../../assets/images/adaptadores.png';
import Facebok from '../../assets/images/Facebok.png';
import Wasa from '../../assets/images/Wasa.png';
import insta from '../../assets/images/insta.png';
import Ubi from '../../assets/images/Ubi.png';
import Telefono from '../../assets/images/Telefono.png';
import Email34 from '../../assets/images/Correo.png';
import checkAnim from '../../assets/images/check.gif';
import RedesFondo from '../../assets/images/Red-Neuronal.png';

import { FaWhatsapp } from 'react-icons/fa';
{/* Bloque de menú catalogo Redes */}
const categoriasRedes = [
  {
    //Item 1 catalogo Redes 
    titulo: 'Switches',
    img: imgSwitch,
    marcas: ['Cisco', 'Ubiquiti', 'TP-Link', 'D-Link', 'Netgear'],
  },
  {
    //Item 2 catalogo Redes 
    titulo: 'Routers',
    img: imgRouter,
    marcas: ['MikroTik', 'Cisco', 'Asus', 'TP-Link', 'Netgear'],
  },
  {
    //Item 3 catalogo Redes 
    titulo: 'Firewalls',
    img: imgFirewall,
    marcas: ['Fortinet', 'Palo Alto', 'Sophos', 'Cisco', 'SonicWall'],
  },
  {
    //Item 4 catalogo Redes 
    titulo: 'Access Points',
    img: imgAccessPoint,
    marcas: ['Ubiquiti', 'Aruba', 'TP-Link', 'Netgear', 'Cambium'],
  },
  {
    //Item 5 catalogo Redes
    titulo: 'Redes Wi-Fi Mesh',
    img: imgWifi,
    marcas: ['Google Nest', 'TP-Link Deco', 'ASUS AiMesh', 'eero', 'Netgear Orbi'],
  },
  {
    //Item 6 catalogo Redes 
    titulo: 'Cables de Red',
    img: imgCableRed,
    marcas: ['Panduit', 'Belden', 'CommScope', 'Tripp Lite', 'Leviton'],
  },
  {
    //Item 7 catalogo Redes 
    titulo: 'Racks y Gabinetes',
    img: imgRacks,
    marcas: ['APC', 'Tripp Lite', 'Panduit', 'StarTech', 'Chatsworth'],
  },
  {
    //Item 8 catalogo Redes
    titulo: 'Conectores RJ45 y Patch Panels',
    img: imgConectores,
    marcas: ['Siemon', 'Panduit', 'Leviton', 'CommScope', 'AMP Netconnect'],
  },
  {
    //Item 9 catalogo Redes
    titulo: 'Fuentes de Poder para Red',
    img: imgFuente,
    marcas: ['APC', 'Eaton', 'CyberPower', 'Tripp Lite', 'Forza'],
  },
  {
    //Item 10 catalogo Redes 
    titulo: 'Adaptadores',
    img: imgAdaptadorRed,
    marcas: ['Intel', 'TP-Link', 'ASUS', 'StarTech', 'D-Link'],
  },
  {
    //Item 11 catalogo Redes 
    titulo: 'Memoria para Servidores',
    img: imgMemoriaSer, 
    marcas: ['Kingston ', 'Crucial', 'Samsung', 'Hynix ', 'Corsair'],
  },
  {
    //Item 12 catalogo Redes 
    titulo: 'Tarjeta de red',
    img: imgTarjetasred, 
    marcas: ['Intel ', 'Broadcom', 'TP-Link', 'ASUS', 'StarTech'],
  },
];


function CatalogoRedes() {
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
    }).then(() => {
      setEnviado(true);
      form.reset();
    });
  };

  return (
    <>
    {/* Bloque de inicio catalogo Redes */}
      <section className="Redes-white-section">
        <div className="Redes-header">
          {/*Titulo de catálogo Redes */}
          <h2 className="Redes-titulo">Redes y Conectividad</h2>

          <div className="Redes-texto-lateral">
            {/*Descripción catalogo Redes */}
            <p className="Redes-contacto-descripcion">
             Equipamiento de red original y confiable para asegurar máxima eficiencia en tu infraestructura.
            </p>
          </div>
        </div>

        <div className="Redes-grid">
          {categoriasRedes.map((cat, idx) => (
            <div className="Redes-item" key={idx}>
              <div className="Redes-img">
                <img src={cat.img} alt={cat.titulo} />
              </div>
              <div className="Redes-texto">
                <h3>{cat.titulo}</h3>
                <p className="Redes-marcas">
                  {cat.marcas.map((marca, i) => (
                    <span key={i} className="Redes-marca-texto">
                      {marca}
                    </span>
                  ))}
                </p>
              </div>
            </div>
          ))}
        </div>

        <p className="Redes-contacto">
          {/*Sugerencia whatsapp catalogo Redes */}
          ¿No encuentras ese componente de red? Podemos conseguirlo.<br />
           &nbsp;&nbsp;&nbsp;&nbsp;Ponte en contacto con{' '}
          <a
            href="https://wa.me/525567786252"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-link"
          >
            nosotros <FaWhatsapp className="whatsapp-icon-inline" />
          </a>
        </p>
      </section>
    {/* Contenedor principal del formulario de contacto */}
 <div className="formulario-imagen-style20">
  <div className="linea-superior20"></div>

  {/*Titulo Formulario*/}
  <h2>
    {/*Titulo cambiado formulario catalogo Redes */}
  {!enviado ? (
    <>
      Optimiza tu red con componentes esenciales.<br />
      ¡Cotiza ahora!
    </>
  ) : (
    <>
      ¡¡¡ GRACIAS POR CONTACTARNOS !!!<br />
        Un especialista se pondrá en contacto contigo.
    </>
  )}
</h2>

  {!enviado ? (
    <form
      onSubmit={handleSubmit}
      action="https://formsubmit.co/ivan.benitez@iatekza.com"
      method="POST"
      className="formulario-simple20"
    >
      <input type="hidden" name="_captcha" value="false" />
{/* Campos de entrada para nombre, teléfono, correo, empresa y mensaje */}

      {/* Campo nombre*/}
      <input type="text" name="nombre" placeholder="Nombre" required />
      {/* Campo  Numero Telefonico*/}
      <input type="tel" name="numero" placeholder="Número Telefónico" required />
      {/* Campo Correo Electronico*/}
      <input type="email" name="correo" placeholder="Correo Electrónico" required />
      {/* Campo Empresa*/}
      <input type="text" name="empresa" placeholder="Empresa (Opcional)" />
      {/* Campo Mensaje*/}
      <textarea name="mensaje" placeholder="Mensaje" required></textarea>
      {/* Botón de envío del formulario */}
      <button type="submit">Enviar</button>
    </form>
  ) : (
    <div className="confirmacion-envio20">
      <img src={checkAnim} alt="Éxito" />
      <p>¡ Mensaje enviado correctamente !</p>
    </div>
  )}
</div>



{/* Contenedor principal  de pie de pagina con contacto*/}
<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>

  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>

  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>

  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        {/* Servicio Consultoria ERP LIBRA colum 2*/}
        <li><a href="/Comercializacion">• Ver mas Infraestructura TI</a></li>
        <li><a href="/">• IAutomatizacion CFDI</a></li>
         
        <li><a href="/Facturacion">• Facturación Electrónica</a></li>
        <li><a href="/Consultoria">• Asesoría Empresarial</a></li>
        {/* Servicio Sistemas colum 2*/}
        <li><a href="/Sistemas">• Soluciones Tecnologícas</a></li>
      </ul>
      {/*Facebook Colum 2*/}
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        {/*Wasak Colum 2*/}
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        {/*Instagram Colum 2*/}
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
         {/*Sobre Nostros Colum 3*/}
        <li><a href="/Nosotros">Sobre nosotros</a></li>
         {/*Casos de Exito Colum 3*/}
        <li><a href="/CasosExito">Casos de Éxito</a></li>
         {/*Facturacion Electronica Colum 3*/}
        {/*Servicios Colum 3*/}
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

{/* Línea de derechos reservados */}
  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>
<a
  href="https://wa.me/525567786252"
  target="_blank"
  rel="noopener noreferrer"
  className="whatsapp-bubble"
>
  <FaWhatsapp size={35} color="#fff" />
</a>
       </>
  );
}


export default CatalogoRedes;
